import React, { Component } from "react";
import { func, arrayOf, shape, bool, string, number } from "prop-types";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import Table from "rc-table";
import { routerActions } from "react-router-redux/actions";

import { actions, selectors } from "reducers/administration/groups";
import { actions as layoutActions } from "reducers/layout";
import * as i18n from "util/i18n";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { getPostLoginHomePath } from "util/v3UxConfig";

import Container from "pages/_components/Container";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import { Checkbox } from "pages/_components/fields/Checkbox";
import Image from "pages/_components/Image";
import Circle from "pages/_components/Circle";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import Head from "pages/_components/Head";
import InfoTag from "pages/_components/InfoTag";

const GroupName = ({ name, massiveEnabled }) => (
    <div className="data-wrapper data-wrapper-flex">
        <span className="data-desc">{name}</span>&nbsp;&nbsp;
        {!massiveEnabled && <Image src="images/key.svg" className="svg-icon svg-caret" />}
    </div>
);

GroupName.propTypes = {
    name: string.isRequired,
    massiveEnabled: bool.isRequired,
};

class AdministrationGroups extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        groups: arrayOf(shape({ idGroup: number, name: string, status: string, usersInGroup: number, blocked: bool }))
            .isRequired,
        groupsExtendedInfo: shape({}),
        fetching: bool,
        fetchingExport: bool,
        fetchingMoreGroups: bool,
        currentPage: number,
        totalPages: number,
        hasMoreData: bool,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        fetching: false,
        fetchingExport: false,
        fetchingMoreGroups: false,
        currentPage: 0,
        totalPages: 0,
        hasMoreData: false,
        groupsExtendedInfo: null,
        embeddedInV3Shell: false,
    };

    state = {
        selectedGroups: new Map(),
        selectAllChecked: false,
        blockedQuantity: 0,
        unblockedQuantity: 0,
    };

    componentDidMount() {
        const { dispatch, embeddedInV3Shell } = this.props;

        dispatch(actions.loadListRequest());
        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatchV3ShellLayout(dispatch, {
                titleKey: "administration.groups",
                goBackPath: getPostLoginHomePath(true),
                rightContentMobile: null,
                scopes: ["administration"],
            });
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;

        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        }
    }

    onRowClick = ({ idGroup }) => {
        const { dispatch } = this.props;

        dispatch(routerActions.push(`/administration/advanced/group/${idGroup}/details`));
    };

    generateTableColumns = (massiveDisabledQuantity) => {
        const { selectAllChecked, selectedGroups } = this.state;
        const { groups } = this.props;

        const columnArray = [
            {
                key: "check",
                dataIndex: "check",
                title: (
                    <Checkbox
                        hideLabel
                        onChange={this.handleSelectAll}
                        name="selectAllGroups"
                        checked={selectAllChecked || groups.length === selectedGroups.length + massiveDisabledQuantity}
                        disabledCheck={groups.length === massiveDisabledQuantity}
                    />
                ),
                width: 20,
                onCell: () => ({
                    onClick(e) {
                        e.stopPropagation();
                    },
                }),
            },
            {
                className: "text-center",
                key: "groupName",
                dataIndex: "groupName",
                title: i18n.get("administration.groups.list.name"),
                width: 300,
            },
            {
                className: "text-center",
                key: "description",
                dataIndex: "description",
                title: i18n.get("administration.groups.list.description"),
                width: 300,
            },
            {
                className: "text-center",
                key: "usersInGrouop",
                dataIndex: "usersInGrouop",
                title: i18n.get("administration.groups.list.usersInGroup"),
                width: 100,
            },
            {
                className: "text-right",
                key: "groupStatus",
                dataIndex: "groupStatus",
                title: i18n.get("administration.groups.list.status"),
                width: 200,
            },
        ];
        return columnArray;
    };

    populateGroupsData = (massiveDisabledQuantity) => {
        const { groups, groupsExtendedInfo } = this.props;
        const { selectedGroups, selectAllChecked } = this.state;
        return groups.map(({ idGroup, name, description, usersInGroup, status }) => ({
            key: idGroup.toString(),
            check: (
                <Checkbox
                    onChange={() => this.handleCheckClick(idGroup, name, massiveDisabledQuantity)}
                    hideLabel
                    id={idGroup}
                    name={idGroup.toString()}
                    checked={
                        groupsExtendedInfo[idGroup].massiveEnabled && (selectAllChecked || selectedGroups.has(idGroup))
                    }
                    disabledCheck={!groupsExtendedInfo[idGroup].massiveEnabled}
                />
            ),
            idGroup,
            groupName: <GroupName name={name} massiveEnabled={groupsExtendedInfo[idGroup].massiveEnabled} />,
            description,
            usersInGrouop: <Circle value={usersInGroup} bgColor="#0071ce" />,
            groupStatus: (
                <div className="data-wrapper data-wrapper-flex">
                    <InfoTag
                        tagClass="ml-auto mr-0 px-2"
                        type="default"
                        message={status}
                        tagBackground={status === "Bloqueado" ? "#fc5f5f" : "#0be0a2"}
                    />
                </div>
            ),
        }));
    };

    renderPageHeader = () => {
        const { fetchingExport } = this.props;
        const { selectedGroups } = this.state;

        return (
            <>
                <div className="admin-detail-head admin-detail-head-section px-0 mt-5 mb-45">
                    <Head
                        title="administration.groups.list.title"
                        exportList
                        toolbarItemClassName="pr-0"
                        handleClick={this.handleClickDownload}
                        handleCreateClick={this.handleCreateGroupClick}
                        isFetchingExport={fetchingExport}
                        hasInlineButtons
                        imageStyle="mr-2">
                        {this.renderActionButtons()}
                    </Head>
                    {selectedGroups.size > 0 && (
                        <div className="pl-2">
                            {selectedGroups.size}{" "}
                            {selectedGroups.size === 1
                                ? i18n.get("administration.groups.list.selected.onlyOne")
                                : i18n.get("administration.groups.list.selected.quantity")}
                        </div>
                    )}
                </div>
            </>
        );
    };

    handleCheckClick = (idGroupChecked, nameGroupChecked, massiveDisabledQuantity) => {
        const { groups } = this.props;
        let { blockedQuantity, unblockedQuantity } = this.state;
        const { selectedGroups, selectAllChecked } = this.state;
        const groupChecked = groups.filter((group) => group.idGroup === idGroupChecked);

        if (!selectedGroups.has(idGroupChecked)) {
            selectedGroups.set(idGroupChecked, nameGroupChecked);
            if (groupChecked[0].blocked) {
                blockedQuantity += 1;
            } else {
                unblockedQuantity += 1;
            }
            if (selectedGroups.size === groups.length - massiveDisabledQuantity) {
                this.setState({
                    selectAllChecked: true,
                });
            }
        } else {
            selectedGroups.delete(idGroupChecked);
            if (groupChecked[0].blocked) {
                blockedQuantity -= 1;
            } else {
                unblockedQuantity -= 1;
            }
            if (selectAllChecked) {
                this.setState({ selectAllChecked: false });
            }
        }
        this.setState({
            selectedGroups,
            blockedQuantity,
            unblockedQuantity,
        });
    };

    handleSelectAll = () => {
        const { selectAllChecked } = this.state;
        const { groups, groupsExtendedInfo } = this.props;
        const newSelectedGroups = new Map();
        let blockedQuantity = 0;
        let unblockedQuantity = 0;
        if (!selectAllChecked) {
            groups.forEach((group) => {
                if (groupsExtendedInfo[group.idGroup].massiveEnabled) {
                    newSelectedGroups.set(group.idGroup, group.name);
                    if (group.blocked) {
                        blockedQuantity += 1;
                    } else {
                        unblockedQuantity += 1;
                    }
                }
            });
        }
        this.setState((prevState) => ({
            selectAllChecked: !prevState.selectAllChecked,
            selectedGroups: newSelectedGroups,
            blockedQuantity,
            unblockedQuantity,
        }));
    };

    handleMoreDataClick = () => {
        const { dispatch, currentPage } = this.props;

        this.setState({ selectAllChecked: false });
        dispatch(actions.loadMoreRequest({ pageNumber: currentPage + 1 }));
    };

    handleClickDownload = (format) => {
        const { dispatch } = this.props;

        dispatch(actions.exportListRequest(format));
    };

    handleActionClick = (action) => {
        const { dispatch } = this.props;
        const { selectedGroups } = this.state;

        dispatch(actions.changeGroupStatusPreview([...selectedGroups.keys()], [...selectedGroups.values()], action));
    };

    handleCreateGroupClick = () => {
        const { dispatch } = this.props;

        dispatch(routerActions.push("/administration/advanced/group/create/step1"));
    };

    renderActionButtons = () => {
        const { selectedGroups, blockedQuantity, unblockedQuantity } = this.state;

        return (
            <div className="flex-container" style={{ marginLeft: "1rem" }}>
                {(selectedGroups.size === 0 || unblockedQuantity > 0) && (
                    <div>
                        <Button
                            bsStyle="link"
                            key="block"
                            label="administration.block"
                            type="button"
                            disabled={unblockedQuantity === 0}
                            onClick={() => this.handleActionClick("block")}
                        />
                    </div>
                )}
                {blockedQuantity > 0 && (
                    <div>
                        <Button
                            bsStyle="link"
                            key="unblock"
                            label="administration.unblock"
                            type="button"
                            onClick={() => this.handleActionClick("unblock")}
                        />
                    </div>
                )}
                <div>
                    <Button
                        bsStyle="link"
                        key="delete"
                        label="administration.delete"
                        type="button"
                        disabled={selectedGroups.size === 0}
                        onClick={() => this.handleActionClick("delete")}
                    />
                </div>
            </div>
        );
    };

    renderTableFooter = () => {
        const { totalPages, hasMoreData, fetchingMoreGroups } = this.props;

        return (
            <div>
                {totalPages > 1 &&
                    (hasMoreData ? (
                        <div className="text-center no-more-data" key="noMoreUsers">
                            <Button
                                className="btn btn-link w-auto"
                                onClick={this.handleMoreDataClick}
                                loading={fetchingMoreGroups}
                                image="images/show.svg"
                                label="administration.groups.list.more"
                            />
                        </div>
                    ) : (
                        <div className="text-center no-more-data" key="noMoreUsers">
                            <p className="text-lead">
                                <I18n id="administration.groups.list.more.noMoreData" />
                            </p>
                        </div>
                    ))}
            </div>
        );
    };

    render() {
        const { groupsExtendedInfo, totalPages, fetching, embeddedInV3Shell } = this.props;
        const massiveDisabledQuantity = Object.values(groupsExtendedInfo).filter((group) => !group.massiveEnabled)
            .length;
        const columns = this.generateTableColumns(massiveDisabledQuantity);
        const showLegacyNotification = !embeddedInV3Shell || !isUxDashboardImprovementsEnabled();

        return (
            <>
                {showLegacyNotification && <Notification scopeToShow="administration" />}
                <PageLoading loading={fetching} className="screen-loader">
                    {this.renderPageHeader()}
                    <MainContainer className="main-container px-0" viewContentClassName="pt-0">
                        <Container
                            className="container--layout mt-0 px-0 flex-grow administration-users-table"
                            rowClassName="mx-0"
                            gridClassName="form-content px-0">
                            <Col xs={12} className="px-0">
                                <Table
                                    columns={columns}
                                    data={this.populateGroupsData(massiveDisabledQuantity)}
                                    rowKey={(record) => record.key}
                                    emptyText={i18n.get("administration.groups.list.noRecords")}
                                    onRow={(record) => ({
                                        onClick: () => this.onRowClick(record),
                                    })}
                                    footer={totalPages > 1 ? this.renderTableFooter : null}
                                    className="table-adminGroups"
                                />
                            </Col>
                        </Container>
                    </MainContainer>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    groups: selectors.getGroups(state),
    groupsExtendedInfo: selectors.getGroupsExtendedInfo(state),
    currentPage: selectors.getCurrentPage(state),
    totalPages: selectors.getTotalPages(state),
    hasMoreData: selectors.getHasMoreData(state),
    fetching: selectors.isFetching(state),
    fetchingMoreGroups: selectors.isFetchingMoreGroups(state),
    fetchingExport: selectors.isFetchingExport(state),
});

export default connect(mapStateToProps)(AdministrationGroups);
